import React from 'react';

import IconButton from '@mui/material/IconButton';

import type { Props } from 'src/components/ui/Icon';
import Icon from 'src/components/ui/Icon';

export type MoreIconProps = {
    ariaLabel: string;
    ariaControls: string;
    ariaHasPopup: string;
    color?: string;
    hoverColor?: string;
    size?: 'small' | 'medium' | 'large';
    iconProps?: Omit<Props, 'name'>;
    'data-target-id'?: string;
};
const MoreIcon: React.FC<MoreIconProps> = ({
    ariaLabel,
    ariaControls,
    ariaHasPopup,
    color,
    hoverColor,
    iconProps,
    ...rest
}) => (
    <IconButton
        aria-haspopup={ariaHasPopup as 'true' | 'false' | undefined}
        aria-label={ariaLabel}
        aria-controls={ariaControls}
        sx={{
            backgroundColor: color,
            ':hover': {
                bgcolor: hoverColor,
            },
        }}
        {...rest}
    >
        <Icon name="DotsHorizontalRounded" {...(iconProps ?? {})} />
    </IconButton>
);

export default MoreIcon;
